import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import { setAuthorization } from "../../../helpers/api_helper";
import { apiLogout } from "../../../helpers/backend_api";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.loginUser,
        user.email,
        user.password
      );
      if (response) {
        yield put(loginSuccess(response));
        history('/dashboard')
      } else {
        yield put(apiError(response));
      }
    } else {
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      });

      // FastAPI response body: { message, data: { access_token | AccessToken, refresh_token, expires_in, login_user_data } }
      // Pydantic .dict() emits field names (snake_case); .dict(by_alias=True) emits aliases (PascalCase) — handle both.
      const payload = response && response.data ? response.data : null;
      const token = payload
        ? payload.access_token || payload.AccessToken || null
        : null;

      if (token) {
        const authUser = {
          ...(payload.login_user_data || {}),
          token,
          refreshToken: payload.refresh_token || payload.RefreshToken || "",
          expiresIn: payload.expires_in || payload.ExpiresIn,
        };
        sessionStorage.setItem("authUser", JSON.stringify(authUser));
        setAuthorization(token);
        yield put(loginSuccess(authUser));
        history('/dashboard');
      } else {
        const message = (response && response.message) || "Login failed";
        yield put(apiError({ data: message }));
      }
    }
  } catch (error) {
    const message = typeof error === "string" ? error : (error && error.message) || "Login failed";
    yield put(apiError({ data: message }));
  }
}

function* logoutUser() {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      sessionStorage.removeItem("authUser");
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {
      const raw = sessionStorage.getItem("authUser");
      const token = raw ? (JSON.parse(raw)?.token || "") : "";
      try {
        yield call(apiLogout, { token });
      } catch (_) {
        // ignore network/server errors on logout — still clear session
      }
      sessionStorage.removeItem("authUser");
      yield put(logoutUserSuccess(LOGOUT_USER, true));
    }
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(
        fireBaseBackend.socialLoginUser,
        data,
        type,
      );
      sessionStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      sessionStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    history('/dashboard')
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
